export default __webpack_public_path__ + "static/media/sling.d917f107.png";